import React, { Component } from 'react';
import PropTypes from 'prop-types';

const HEIGHT_TO_WIDTH_RATIO = 1.15;

const withSliderLogic = Slider =>
  class extends Component {
    static propTypes = {
      photos: PropTypes.arrayOf(
        PropTypes.shape({
          image: PropTypes.string.isRequired,
          id: PropTypes.number.isRequired,
        }),
      ),
      sliderImageOptions: PropTypes.shape().isRequired,
    };

    static defaultProps = {
      photos: [],
      sliderImageOptions: {
        height: 70,
        width: 100,
        marginRight: 10,
      },
    };

    state = {
      id: null,
      index: 0,
      left: 0,
      fullScreenSlideWidth: 800,
    };

    componentDidMount() {
      window.addEventListener('keyup', this.handleKeyboardClick);
      /* eslint-disable react/no-did-mount-set-state */
      this.setState({
        fullScreenSlideWidth: Math.round(window.innerHeight * HEIGHT_TO_WIDTH_RATIO),
      });
    }

    componentWillUnmount() {
      window.removeEventListener('keyup', this.handleKeyboardClick);
    }

    setNextId = e => {
      if (e) {
        e.stopPropagation();
      }
      const { photos } = this.props;
      const { id } = this.state;
      const index = photos.findIndex(photo => photo.id === id);

      this.setState({ id: photos[(photos.length + index + 1) % photos.length].id });
      this.setSliderPosition();
    };

    setPrevId = () => {
      const { photos } = this.props;
      const { id } = this.state;
      const index = photos.findIndex(photo => photo.id === id);

      this.setState({ id: photos[(photos.length + index - 1) % photos.length].id });
      this.setSliderPosition();
    };

    setImageId = id => {
      this.setState({ id });
    };

    setSliderPosition = () => {
      const { id } = this.state;
      const { photos, sliderImageOptions } = this.props;
      const { width, marginRight } = sliderImageOptions;
      const fullImageWidth = width + marginRight;
      const windowWidth = window.innerWidth;
      const sliderWidth = photos.length * fullImageWidth;

      if (sliderWidth > windowWidth) {
        const maxLeft = sliderWidth - windowWidth;
        const currentImageIndex = photos.findIndex(photo => photo.id === id);
        const imageLeft = currentImageIndex * fullImageWidth;
        const left = imageLeft - windowWidth / 2 < maxLeft ? imageLeft - windowWidth / 2 : maxLeft;

        this.setState({ left: left > 0 ? left : 0 });
      }
    };

    setFullscreenImage = e => {
      const id = parseFloat(e.target.id);
      this.setState({ id });
      this.setSliderPosition();
    };

    setPreviewImage = index => {
      this.setState({ index: parseFloat(index) });
    };

    decrementIndex = () => {
      const { photos } = this.props;
      const { index } = this.state;

      this.setState({ index: (photos.length + index - 1) % photos.length });
    };

    incrementIndex = () => {
      const { photos } = this.props;
      const { index } = this.state;

      this.setState({ index: (photos.length + index + 1) % photos.length });
    };

    closeSlider = () => {
      this.setState({ id: null });
    };

    handleKeyboardClick = e => {
      const { id } = this.state;
      const { key } = e;

      if (key === 'ArrowLeft') {
        if (id) {
          this.setPrevId();
        } else {
          this.decrementIndex();
        }
      } else if (key === 'ArrowRight') {
        if (id) {
          this.setNextId();
        } else {
          this.incrementIndex();
        }
      } else if (key === 'Escape') {
        this.closeSlider();
      }
    };

    render() {
      const { id, index, left, fullScreenSlideWidth } = this.state;
      const newProps = {
        id,
        index,
        left,
        fullScreenSlideWidth,
        setFullscreenImage: this.setFullscreenImage,
        closeSlider: this.closeSlider,
        setPrevId: this.setPrevId,
        setNextId: this.setNextId,
        setPreviewImage: this.setPreviewImage,
        incrementIndex: this.incrementIndex,
        decrementIndex: this.decrementIndex,
        setImageId: this.setImageId,
      };

      return <Slider {...this.props} {...newProps} />;
    }
  };

export default withSliderLogic;



// WEBPACK FOOTER //
// ./src/shared/hocs/withSliderLogic.js